module.exports = __webpack_public_path__ + "img/ycc.7e6b72ce.png";